import * as React from 'react';
import * as ReactDOM from 'react-dom';
import fetch from 'unfetch';
import { Property } from './Property';
import { GlobalStyle } from './GlobalStyles';
import { IPropertyResult } from './api';
import styled from 'styled-components';

interface IOfficeProps {
  officeId: number;
}

const App = (props: IOfficeProps) => {
  const [page, setPage] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  const [total, setTotal] = React.useState(0);

  const [state, setState] = React.useState<{
    loading: boolean;
    properties: IPropertyResult[];
  }>({ loading: false, properties: [] });

  React.useEffect(() => {
    setState({ ...state, loading: true });

    fetch(
      `https://www.garanti.no/api/search/estate?kontor_id=${props.officeId}&page=${page}&max=8`
    )
      .then((res: Response) => res.json())
      .then((res: any) => {
        if (res && res.hits) {
          setState({ loading: false, properties: res.hits });
          setTotal(res.total);
        }
      })
      .catch((e) => {
        setState({ loading: false, properties: [] });
      });
  }, [, page]);

  React.useEffect(() => {
    setTotalPages(Math.ceil(total / 8));
  }, [total]);

  const handleNext = () => {
    setPage(page + 1);
  };

  const handlePrev = () => {
    setPage(page - 1);
  };

  return (
    <Main>
      <GlobalStyle />
      {state.loading ? (
        <div>Laster inn</div>
      ) : (
        <div>
          {state && state.properties.length > 0 ? (
            <>
              {state.properties
                .filter((item) => item)
                .map((property: any, index: number) => {
                  return <Property key={`property_${index}`} data={property} />;
                })}
              <Pagination
                hasPrev={page - 1 >= 0}
                hasNext={totalPages > page + 1}
                onPrev={() => handlePrev()}
                onNext={() => handleNext()}
              />
            </>
          ) : (
            <div>Fant ingen eiendommer</div>
          )}
        </div>
      )}
    </Main>
  );
};

const param = window.location.search.replace('?', '').split('=');
let id: number = 0;
if (param && param[0] && param[0] === 'id') {
  id = parseInt(param[1], 10);
}

const Main = styled.div`
  padding: 1em;
  background-color: #fff;
`;

interface IPagination {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

const Pagination: React.FC<IPagination> = ({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
}) => {
  return (
    <PaginationNav>
      {hasPrev ? (
        <PaginationButton onClick={onPrev}>Forrige</PaginationButton>
      ) : null}
      {hasNext ? (
        <PaginationButton onClick={onNext}>Neste</PaginationButton>
      ) : null}
    </PaginationNav>
  );
};

const PaginationNav = styled.nav`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-column-gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const PaginationButton = styled.button`
  padding: 10px;
  background: rgb(200, 200, 200);
  border: none;
  appearance: none;

  &:hover {
    cursor: pointer;
  }
`;

ReactDOM.render(<App officeId={id} />, document.getElementById('app'));
